module.exports = __webpack_public_path__ + "assets/b78e34d206b6ca72a3e9c3fd16ab205b.png";